import paper from 'paper';

function onMouseDrag (event) {
   var delta = event.downPoint.subtract(event.point)
    paper.view.scrollBy(delta)
}

export const tool = new paper.Tool();
tool.onMouseDrag = onMouseDrag;
